import React from 'react';
import ButtonRolesAction from '../ButtonRolesAction/ButtonRolesAction';
import {ReactComponent as UpdateIcon} from '../../images/updateIcon.svg';
import {ReactComponent as BurgerIcon} from '../../images/burgerIcon.svg';
import './RolesActions.css';
import Tabs from '../Tabs/Tabs';
const RolesActions = ({
  handleSelectedPopup,
  updateTabData,
  handleTabSelected,
  tabs,
  selectedTab,
}) => {
  return (
    <div className='roles-actions'>
      <div className='roles-actions__left-wrapper'>
        <ButtonRolesAction
          onClick={() => updateTabData(selectedTab)}
          children={<UpdateIcon />}
        />
        <ButtonRolesAction children={<BurgerIcon />} />
        <Tabs handleTabSelected={handleTabSelected} tabs={tabs} />
      </div>
      <ButtonRolesAction
        onClick={() => handleSelectedPopup(selectedTab)}
        children={'+ ДОБАВИТЬ'}
        className={'ButtonRolesAction_add'}
      />
    </div>
  );
};

export default RolesActions;
